import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { env } from '../../../config/index';
import { Row, Col, Card, Form, Input, Button, Typography, Grid, Modal, Space, Tag, message } from 'antd';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function CheckStatus() {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState(null);

  const { xs } = useBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    setTimeout(() => {
      axios.get(`${env}/wchss/check_status`, {
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: values
      })
      .then(response => {
        const { data } = response.data
        
        setData(data)

        if(data.transactionNumber){
          setIsModalVisible(true);
        }else{
          message.info('Transaction Number does not match!')
        }
      }).catch(error => {
        message.error(error)
      })
    }, 500);
  }

  const onFinishFailed = (errorInfo) => {
    message.error(errorInfo);
  }

  const status = (
    data?.transactionStatus === 'WAITING_FOR_PAYMENT' ?
      <Tag color="yellow">
        Waiting For Payment
      </Tag>
    : data?.transactionStatus === 'PAYMENT_CONFIRMED' ? 
      <Tag color="orange">
        Waiting For Verification
      </Tag>
    : data?.transactionStatus === 'CONFIRMED' ? 
      <Tag color="green">
        Payment Confirmed
      </Tag>
    : data?.transactionStatus === 'REJECTED' ? 
      <Tag color="red">
        Rejected
      </Tag>
    : 
      'Transaksi Tidak ditemukan'
  )

  return (
    <React.Fragment>
      <Row style={{ marginTop: xs ? 8 : 64 }}>
        <Col xs={{ span: 24 }} lg={{ span: 16, offset: 4 }}>
          <Card style={{ borderRadius: 8, textAlign: 'center' }}>
            <Text style={{ fontSize: 22, fontWeight: 'bold' }}>Check Your Registration Status</Text>
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{ marginTop: 32 }}
            >
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 16, offset: 4 }}>
                  <Form.Item  name="transactionNumber" label="Registration Number" initialValue="">
                    <Input />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType='submit' block>Search</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
      <Modal title="Transaction Status" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={false} width={600}>
        <Space direction="vertical" size={8}>
          <Text>Registration Number: <Text style={{ fontWeight: 'bold' }}>{data?.transactionNumber}</Text></Text>
          <Text>Status: {status}</Text>
          {
            data?.transactionStatus === 'PAYMENT_CONFIRMED' ?
              <Text>Your transfer proof has been Uploaded. We will check your transaction in <Text strong>3x24</Text> hours</Text>
            : null
          }
          {
            data?.transactionStatus === 'CONFIRMED' ? 
              <a href="https://chat.whatsapp.com/IwygQDG6AdR4ZulV5ImV3Y" target="_blank" rel="noreferrer">
                <Button type='primary'>click here to join whatsapp group</Button>
              </a>
            : null
          }
        </Space>
      </Modal>
    </React.Fragment>
  )
}

export default CheckStatus  